import { selector } from 'recoil';
import {
  LOOKUP_UI_INCORRECT_PART_STATE,
  LOOKUP_UI_INITIAL_STATE,
  LOOKUP_UI_MULTIPLE_PARTS_STATE,
  LOOKUP_UI_OOW_WITHOUT_PRICE_STATE,
  LOOKUP_UI_STATE_MAP,
} from 'utils/constants';
import { isOutOfWarrantyWithoutRepairFee } from 'utils/helpers';

import { currentRmaState, checkoutState, lookupState } from './atoms';

export const storageCurrentRmaSelector = selector({
  key: 'currentRmaSelector',
  get: ({ get }) => get(currentRmaState),
  set: ({ set }, newValue) => {
    localStorage.setItem('current-rma', JSON.stringify(newValue));
    set(currentRmaState, newValue);
  },
});

export const storageCheckoutSelector = selector({
  key: 'checkoutSelector',
  get: ({ get }) => get(checkoutState),
  set: ({ set }, newValue) => {
    localStorage.setItem('rma-checkout', JSON.stringify(newValue));
    set(checkoutState, newValue);
  },
});

/**
 * Defines the view state based on the lookup results
 */
export const lookupViewSelector = selector({
  key: 'lookupViewSelector',
  get: ({ get }) => {
    const { lookupResults, selectedResult, incorrectPartNumber } = get(lookupState);

    // Initial lookupState view
    if (!lookupResults.length) {
      return LOOKUP_UI_INITIAL_STATE;
    }

    // Multiple parts view
    if (lookupResults.length > 1) {
      return LOOKUP_UI_MULTIPLE_PARTS_STATE;
    }

    if (incorrectPartNumber) {
      return LOOKUP_UI_INCORRECT_PART_STATE;
    }

    // Out Of Warranty without repair fee
    if (isOutOfWarrantyWithoutRepairFee(selectedResult)) {
      return LOOKUP_UI_OOW_WITHOUT_PRICE_STATE;
    }

    // Map view based on warranty result
    return LOOKUP_UI_STATE_MAP[selectedResult.status];
  },
});
